import { Component, Prop, Vue } from 'vue-property-decorator'
import BillingCardComponent from '@/modules/billing-module/shared/components/card/billing-card.vue'
import { InvoiceStatus, InvoiceResponse } from '@/api/services/billing/common-invoice/billing-common-invoice.dto'
import { Nullable, StrictNullable } from '@/shared/types/app.types'
import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'

@Component({
    components: {
        BillingCardComponent
    }
})
export default class BillingModalInvoicesCrudCard extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly deliveryNotes!: BillableDeliveryNoteResponse[]
    @Prop({ type: Object }) readonly invoice!: Nullable<InvoiceResponse>

    get title(): string {
        return this.invoice?.label ?? this.$tc('accounting.field.newInvoice')
    }

    get statusName(): string | undefined {
        return this.invoice?.status.translatedName
    }
    get statusClass(): StrictNullable<string> {
        if (this.invoice) {
            switch (this.invoice.status.code) {
            case InvoiceStatus.GENERATED:
                return 'state-primary'
            case InvoiceStatus.CANCELLED:
                return 'state-archived'
            case InvoiceStatus.VERIFIED:
                return 'state-success'
            }
        }
        return null
    }

    get customerName(): string | undefined {
        let customer = this.invoice?.customer
        if (!customer && this.deliveryNotes.length) {
            customer = this.deliveryNotes[0].customer
        }
        return customer?.name
    }

    get dateLabel(): string {
        if (this.invoice) {
            switch (this.invoice.status.code) {
            case InvoiceStatus.GENERATED:
                return 'accounting.field.generationDate'
            case InvoiceStatus.CANCELLED:
                return 'accounting.field.cancellationDate'
            case InvoiceStatus.VERIFIED:
                return 'accounting.field.verificationDate'
            }
        }
        return 'accounting.field.generationDate'
    }
    get dateValue(): StrictNullable<string> {
        if (this.invoice) {
            switch (this.invoice.status.code) {
            case InvoiceStatus.GENERATED:
                return this.invoice.generationDate
            case InvoiceStatus.CANCELLED:
                return this.invoice.cancellationDate
            case InvoiceStatus.VERIFIED:
                return this.invoice.verificationDate
            }
        }
        return null
    }

    get responsibleLabel(): string {
        if (this.invoice) {
            switch (this.invoice.status.code) {
            case InvoiceStatus.GENERATED:
                return 'accounting.field.generationResponsible'
            case InvoiceStatus.CANCELLED:
                return 'accounting.field.cancellationResponsible'
            case InvoiceStatus.VERIFIED:
                return 'accounting.field.verificationResponsible'
            }
        }
        return 'accounting.field.generationResponsible'
    }
    get responsibleName(): string {
        if (this.invoice) {
            switch (this.invoice.status.code) {
            case InvoiceStatus.GENERATED:
                return this.invoice.generator?.fullName ?? '-'
            case InvoiceStatus.CANCELLED:
                return this.invoice.canceller?.fullName ?? '-'
            case InvoiceStatus.VERIFIED:
                return this.invoice.verifier?.fullName ?? '-'
            }
        }
        return '-'
    }

    get accountingUnitSymbol(): string | undefined {
        let accountingUnit = this.invoice?.conceptsAccountingUnit
        if (
            !accountingUnit &&
            this.deliveryNotes.length &&
            this.deliveryNotes[0].conceptsAccountingUnit
        ) {
            accountingUnit = this.deliveryNotes[0].conceptsAccountingUnit
        }
        return accountingUnit?.symbol
    }
    get conceptsTotalValue(): number {
        if (this.invoice) {
            return this.invoice.conceptsTotalValue ?? 0
        }
        return this.deliveryNotes.reduce((accumulator, deliveryNote) => {
            return accumulator + (deliveryNote.conceptsTotalValue ?? 0)
        }, 0)
    }
}
